
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Tabs, Tab } from '@material-ui/core';
import { MatchChooseItem } from './view';
import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import MatchType from '../../model/MatchType';
import AppUtils from '../../control/apputlis';
import TabIndicator from '../view/TabIndicator';


class MatchChoose extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            competitions: [],
            data: [],
        };
        console.log('MatchChoose', props);
        document.body.style.overflow = 'scroll';
    }

    componentDidMount() {
        this.getSchedusMatch();
        AppUtils.YMPush('MAIN', 'MatchChoose');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _handleChange = (val) => {
        let { competitions } = this.state;
        let data = [];
        if (val == 0) {
            data = competitions;
        } else if (val == 2) {
            for (let i = 0; i < competitions.length; i++) {
                if (competitions[i].lottery_type == 101) {
                    data.push(competitions[i]);
                }
            }
        } else if (val == 3) {
            for (let i = 0; i < competitions.length; i++) {
                if (competitions[i].lottery_type == 301 || competitions[i].lottery_type == 404) {
                    data.push(competitions[i]);
                }
            }
        } else if (val == 4) {
            for (let i = 0; i < competitions.length; i++) {
                if (competitions[i].lottery_type == 401) {
                    data.push(competitions[i]);
                }
            }
        }
        this.setState({ data: data, value: val });
    }

    _onClickItem = (val) => {
        console.log('_onClickItem', val);
        let { data } = this.state;
        for (let i = 0; i < data.length; i++) {
            if (data[i].competition_id == val.competition_id) {
                data[i].selected = !data[i].selected;
            }
        }
        this.setState({ data: data });
    }

    _onClickAll = () => {
        let { data } = this.state;
        for (let i = 0; i < data.length; i++) {
            data[i].selected = true;
        }
        this.setState({ data: data });
    }

    _onClickRevers = () => {
        let { data } = this.state;
        for (let i = 0; i < data.length; i++) {
            data[i].selected = !data[i].selected;
        }
        this.setState({ data: data });
    }

    _onClickConfirm = () => {
        let selectedData = [];
        let { data } = this.state;
        for (let i = 0; i < data.length; i++) {
            if (data[i].selected) {
                selectedData.push(data[i]);
            }
        }
        let { type_id } = this.props.match.params;
        AppUtils.setStorageObj(AppUtils.MATCH_SELECTED + type_id, selectedData);
        console.log('_onClickConfirm', AppUtils.MATCH_SELECTED + type_id, selectedData);
        window.history.back();
    }

    isSelected = (item) => {
        let { type_id } = this.props.match.params;
        let filterData = AppUtils.getStorageObj(AppUtils.MATCH_SELECTED + type_id);
        if (filterData && filterData.length > 0) {
            for (let i = 0; i < filterData.length; i++) {
                if (item.competition_id == filterData[i].competition_id) {
                    return true;
                }
            }
        }
        return false;
    }

    getSchedusMatch = async () => {
        let { type_id } = this.props.match.params;

        let competitions = [];
        let data = AppData.getSchedusMatchData(type_id);
        if (data && data.length > 0) {
            competitions = data;
        } else {
            let result = await Apis.encryptionMatch(this.state.value + 1);
            console.log('getSchedusMatch', result);
            if (result.code == 200) {
                competitions = result.data;
            }
        }

        let ddata = [];
        for (let i = 0; i < competitions.length; i++) {
            let isExast = false;
            ddata.forEach(item => {
                if (item.competition_id == competitions[i].competition_id) {
                    isExast = true;
                    item.match_num++;
                }
            });
            if (!isExast) {
                competitions[i].match_num = 1;
                competitions[i].selected = this.isSelected(competitions[i]);
                ddata.push(competitions[i]);
            }
        }
        this.setState({ competitions: ddata, data: ddata });
    }



    render() {
        const { classes } = this.props;
        const { value, data, } = this.state;
        // let { type_id } = this.props.location.data;  
        let { type_id } = this.props.match.params;

        return ( 
            <MBack title='选择赛事'>
                <Grid container justifyContent='space-between' alignItems='center' direction='row'>
                    {
                        type_id == MatchType.FOOTBALL && <Grid container alignItems='center' style={{ flex: 1, backgroundColor: '#FFF', marginTop: 8, width: '100vw' }}>
                            <Tabs
                                value={value}
                                variant='fullWidth'
                                onChange={(e, val) => this._handleChange(val)}
                                TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                                style={{ minHeight: 32, width: '100vw' }}
                            >
                                <Tab label='全部' style={{ color: value == 0 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='一级赛事' style={{ color: value == 1 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='竞彩' style={{ color: value == 2 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='北单' style={{ color: value == 3 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='足彩' style={{ color: value == 4 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                            </Tabs>
                        </Grid>
                    }
                    {
                        type_id == MatchType.BASKETBALL && <Grid container alignItems='center' style={{ flex: 1, backgroundColor: '#FFF', marginTop: 8, width: '100vw' }}>
                            <Tabs
                                value={value}
                                variant='fullWidth'
                                onChange={(e, val) => this._handleChange(val)}
                                TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                                style={{ minHeight: 32, width: '100vw' }}
                            >
                                <Tab label='全部' style={{ color: value == 0 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='一级赛事' style={{ color: value == 1 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='竞彩' style={{ color: value == 2 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                                <Tab label='北单' style={{ color: value == 3 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                            </Tabs>
                        </Grid>
                    }

                    <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                </Grid>
                <Grid container direction='row' spacing={1} className={classes.list} >
                    {
                        data.map((item, i) => (
                            <Grid item xs={4} key={i}  >
                                <MatchChooseItem selected={item.selected} data={item} onClick={(val) => this._onClickItem(val)} />
                            </Grid>
                        ))
                    }
                </Grid>
                <Grid container direction='column' alignItems='center' className={classes.fexedBottom}>
                    <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                    <Grid container direction='row' alignItems='center' style={{ height: 49 }}>
                        <Grid container direction='row' alignItems='center' style={{ width: 120, flex: 1 }}>
                            <ButtonBase onClick={() => this._onClickAll()} className={classes.button}>全选</ButtonBase>
                            <Grid style={{ width: 1, height: 10, backgroundColor: '#E1E1E1' }}></Grid>
                            <ButtonBase onClick={() => this._onClickRevers()} className={classes.button}>反选</ButtonBase>
                        </Grid>
                        <ButtonBase onClick={() => this._onClickConfirm()} className={classes.confirmButton}>确定</ButtonBase>
                    </Grid>
                </Grid>
            </MBack>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    list: {
        padding: theme.spacing(1, 0, 6, 1),
        backgroundColor: '#FFF',
    },
    button: {
        width: 50,
        height: 35,
        color: '#0D0D0D',
        fontSize: 13,
    },
    confirmButton: {
        width: 110,
        height: 35,
        background: '#007AFF',
        color: '#FFF',
        fontSize: 13,
        marginRight: 8,
        borderRadius: 10,
    },
    fexedBottom: {
        position: 'fixed',
        bottom: 0,
        height: 50,
        boxShadow: '1px 1px 3px #F0F0F0',
        width: '100vw',
        backgroundColor: '#FFF'
    },

}))(MatchChoose));